import { FC } from 'react';
import Typhography from '../../shared/Typhography/Typhography';
import { CustomSection } from '../../shared/CustomSection/CustomSecton';
import CustomButton from '../../shared/CustomButton/CustomButton';
import { usePlanStatus } from '../../hooks/usePlanStatus';
import styles from './AbbonamentoPage.module.scss';

export const AbbonamentoPage: FC = () => {
  const { data, isLoading } = usePlanStatus();

  if (isLoading || !data) {
    return (
      <div className="container-page">
        <Typhography size="regular-14">Caricamento...</Typhography>
      </div>
    );
  }

  const {
    plan,
    currentAthleteCount,
    effectiveMaxAthletes,
    percentUsed,
    isOverLimit,
  } = data;

  const handleSupport = () => {
    window.location.href =
      'mailto:supporto@leopart.com?subject=Upgrade%20piano%20Leopart';
  };

  const barClass = isOverLimit
    ? styles.barOver
    : percentUsed >= 80
    ? styles.barWarn
    : styles.bar;

  const features = plan.features ? Object.entries(plan.features) : [];

  return (
    <div className="container-page">
      <div className="d-flex flex-column mb-3 gap-1">
        <Typhography type="h1" size="bold-24">
          Abbonamento
        </Typhography>
        <Typhography size="regular-14" className={styles.muted}>
          Gestisci il piano e visualizza l'utilizzo
        </Typhography>
      </div>

      <div className="d-flex flex-column gap-2">
        <CustomSection className="p-3">
          <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
            <div className="d-flex flex-column gap-1">
              <Typhography type="h2" size="bold-20">
                {plan.name}
              </Typhography>
              {plan.description && (
                <Typhography size="regular-14" className={styles.muted}>
                  {plan.description}
                </Typhography>
              )}
            </div>
            <span className={styles.priceChip}>€{plan.price}/mese</span>
          </div>

          <div className={styles.quotaBlock}>
            <div className="d-flex justify-content-between align-items-baseline mb-2">
              <Typhography size="medium-14">Atleti utilizzati</Typhography>
              <Typhography size="bold-14">
                {currentAthleteCount} / {effectiveMaxAthletes}
              </Typhography>
            </div>
            <div className={styles.barTrack}>
              <div
                className={barClass}
                style={{ width: `${Math.min(100, percentUsed)}%` }}
              />
            </div>
            {isOverLimit && (
              <Typhography size="regular-12" className={styles.warnLabel}>
                Hai superato il limite del piano. Contatta il supporto per
                aggiornarlo.
              </Typhography>
            )}
          </div>
        </CustomSection>

        {features.length > 0 && (
          <CustomSection className="p-3">
            <Typhography size="bold-16" className="mb-3">
              Features incluse
            </Typhography>
            <div className="d-flex flex-column">
              {features.map(([k, v]) => (
                <div key={k} className={styles.featureRow}>
                  <Typhography size="medium-14">{k}</Typhography>
                  <Typhography size="regular-14" className={styles.muted}>
                    {String(v)}
                  </Typhography>
                </div>
              ))}
            </div>
          </CustomSection>
        )}

        <CustomSection className="p-3">
          <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
            <div className="d-flex flex-column gap-1">
              <Typhography size="bold-16">
                Hai bisogno di più atleti?
              </Typhography>
              <Typhography size="regular-14" className={styles.muted}>
                Per aggiornare il piano contatta il supporto LeoPart.
              </Typhography>
            </div>
            <CustomButton color="outline" onClick={handleSupport}>
              Contatta supporto
            </CustomButton>
          </div>
        </CustomSection>
      </div>
    </div>
  );
};

export default AbbonamentoPage;
